
























// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import apiMedia from '@/api/media'
import {IFileUpload} from '@/models/IFileUpload'
import { AloMedia ,getDefaultAloMedia} from '@/models/alo/AloMedia'
import { directPayloadQuery } from '@/utils/api'
import ImageDetail from '@/components/image/ImageDetail.vue'
import ImageDetailUpload from '@/components/image/ImageDetailUpload.vue'
import EditImage from '@/components/image/EditImage.vue'
import { toNumberDictionary } from '@/utils/groupBy';
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import { getImageUrl } from '@/utils/images'
import cloneDeep from 'clone-deep'

@Component({
  name: 'ReadImage',
  props:{
    imgs:{
      type:Array,
      default:()=>[]
    },
    title:{
      type:String,
      default:'Image'
    },
    name:{
      type:String,
      default:null
    },
    loading:{
      type:Boolean,
      default:false
    },
    maxImages:{
      type:Number,
      default:50,  
    }
  },
  components:{
    ImageDetail,ImageDetailUpload,EditImage
  }   
})
export default class ReadImage extends Vue {
  
  //chaine ordonnée des ids des images    
  private title!:String  
  private maxImages!:number
  private imgs!:Array<AloMedia>
  private images:Array<AloMedia> = []
  private loading!:boolean 
  private uploading:boolean = false     
  private filesToUpload:Array<IFileUpload> = []  
  private dhover = false  
  private files:any = []  
  private name!:String|null
  
  get nbImgAllowed(){
    return Math.max(this.maxImages - this.images.length,0)
  } 

  created(){    
  }

  mounted(){
    this.images = cloneDeep(this.imgs)
  }
      
  @Watch('imgs')
  onImgsChanged() {
    this.images = cloneDeep(this.imgs)
  }

  onImagesAdded(files:File[]){        
    this.dhover = false        
    if(this.nbImgAllowed > 0)  
    {
       if(files.length > 0) {
        this.filesToUpload.push(...files.filter(f => f.type.startsWith('image')).map(f => {               
          const it = {file:f,img:null,progress:0}      
          const reader = new FileReader()
          reader.onload = (e) => {
            //@ts-ignore
            it.img = e.target.result        
          }
          reader.readAsDataURL(it.file)            
          return it
        }))
        this.files = []
       }     
     }
     else {
       this.$confirm("Vous ne pouvez plus ajouter d'image. Le nombre maximal d'image a été atteint",{title: "Attention",buttonTrueText:"Ok",buttonFalseText:""} as VuetifyConfirmObject)
     }
  }   

  editImage(img:AloMedia) { 
    (this.$refs.editImage as EditImage).edit(img) 
  }

  deleteImage(img:AloMedia) {
    this.$confirm("Voulez vous vraiment supprimer l'image?",{title: "Attention",buttonTrueText:"Supprimer",buttonFalseText:"Annuler"} as VuetifyConfirmObject).then(answer=>{
      if(answer){        
        directPayloadQuery(apiMedia.deleteMedia,img.id).then((image) => {    
          const idxToDeleted = this.images.findIndex(i => i.id == img.id)
          if(idxToDeleted > -1){
            this.images.splice(idxToDeleted,1)
            this.$emit("imageDeleted",this.images)
          }            
        })    
      }
    })    
  } 

  deleteUpload(fileToUpload:IFileUpload){
    const idx = this.filesToUpload.findIndex(it => it == fileToUpload) 
    if(idx > -1) this.filesToUpload.splice(idx,1)
  }  

  uploadImage(fileToUpload:IFileUpload){            
    this.uploadImages([fileToUpload])
  }

  uploadAllImages() {    
    this.uploadImages(this.filesToUpload)    
  }
 
  updateImage(img:AloMedia) {
    this.$emit("update",img)   
  }
  
  uploadImages(filesToUpload:Array<IFileUpload>) {  
    if(this.nbImgAllowed > 0)  
     {               
      if(this.nbImgAllowed < filesToUpload.length)  {       
         this.$confirm(`Seul ${this.nbImgAllowed==1?'la première image sera envoyée':`les ${this.nbImgAllowed} premières images seront envoyées`}. Voulez vous continuer`,{title: "Attention trop d'images",buttonTrueText:"Continuer",buttonFalseText:"Arreter"} as VuetifyConfirmObject)
         .then((continuer)=> {
           if(continuer) this.doUploadImages(filesToUpload.splice(0,Math.min(this.nbImgAllowed,filesToUpload.length)))
         })         
       }
       else {
         this.doUploadImages(filesToUpload)
       } 
    }
     else {
       this.$confirm("Vous ne pouvez plus envoyer d'image. Le nombre maximal d'image a été atteint",{title: "Attention",buttonTrueText:"Ok",buttonFalseText:""} as VuetifyConfirmObject)
     } 
  }
  
  doUploadImages(filesToUpload:Array<IFileUpload>) {      
     this.uploading = true
    let hasAdded = false      
    const queries:Array<Promise<void | AloMedia>> = []    
    filesToUpload.forEach(fileToUpload => {            
        fileToUpload.progress = 1    
        queries.push(directPayloadQuery(apiMedia.upload,
                      {   
                        file:fileToUpload.file,
                        name:this.name,
                        progress:(e:ProgressEvent)=>{
                          fileToUpload.progress =  Math.round( ( e.loaded / e.total ) * 100 )                        
                        }                                         
                      }).then(img => {      
                          hasAdded = true
                          this.images.push(img)             
                          //supprime l'image chargée
                          this.deleteUpload(fileToUpload)
                        })
                      )          
    })
    Promise.all(queries).finally(() => {
        if(hasAdded) this.$emit("imagesAdded",this.images)       
        this.uploading = false
    })                 
  }

  onOrderChange(temPhotosIds:string) {
    this.$emit("onOrderChange",this.images)   
  }

  
}
